module.exports = __webpack_public_path__ + "img/experiencedMan.0d5f26c4.jpg";